import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHotdog = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.872 5.844a2.63 2.63 0 0 1 2.677.047l7.89 4.914a2.61 2.61 0 0 1 1.223 2.36v.006l-.001.014-5.527-3.442a1 1 0 0 0-.11-.068L8.577 6.283a1 1 0 0 0-.11-.068zm-1.667.895a.75.75 0 0 0 .293.065q.162.052.314.147l.562.35-.028 3.598-2.157-1.343a1.5 1.5 0 0 1-.324-.274 1 1 0 0 0-.08-.1 1.46 1.46 0 0 1-.064-1.64l.077-.123a1.46 1.46 0 0 1 1.407-.68m.023-1.503a4.126 4.126 0 0 1 5.113-.62l.001.001 7.889 4.914a4.11 4.11 0 0 1 1.929 3.708 4 4 0 0 1-.225 1.15 2.96 2.96 0 0 1-.052 3.046l-.077.123a2.96 2.96 0 0 1-2.709 1.39 4.126 4.126 0 0 1-5.112.62v-.001l-7.89-4.914a4.12 4.12 0 0 1-1.898-4.054v-.004a4.2 4.2 0 0 1 .197-.804 2.96 2.96 0 0 1 .054-3.041l.077-.124a2.96 2.96 0 0 1 2.703-1.39m12.914 9.393c.685.426.895 1.328.468 2.013l-.077.124a1.46 1.46 0 0 1-1.41.68.75.75 0 0 0-.292-.066 1.5 1.5 0 0 1-.312-.146l-.343-.214.025-3.6zm-5.365 3.664c.84.522 1.872.505 2.679.046l-3.15-1.961a1 1 0 0 1-.117-.074l-2.679-1.667-.066-.042-2.694-1.677a1 1 0 0 1-.118-.074l-2.968-1.848a2.62 2.62 0 0 0 1.224 2.383zm1.93-5.803-.025 3.6-1.287-.801.029-3.598zm-4.081 1.074 1.277.795.028-3.597-1.277-.795zm-1.464-4.527-1.295-.806-.028 3.598 1.294.806z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHotdog;
